const DESKTOP_BREAKPOINT = 1200;
const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

// ── Desktop: mega menu (hover) ────────────────────────────────────────────────

export const initMegaMenu = () => {
  const triggers = document.querySelectorAll('.navbar__mega-wrap > ul > .menu-item-has-children');
  if (!triggers.length) return;

  const header = document.getElementById('header');

  const setMegaTop = (panel) => {
    if (!header) return;
    panel.style.top = header.getBoundingClientRect().bottom + 'px';
  };

  const setL2Height = (l2wrap, activePanel) => {
    if (!l2wrap) return;
    if (activePanel) {
      // Mierzymy wysokość aktywnego panelu przez chwilowe uwidocznienie go poza flow
      activePanel.style.position = 'static';
      const h = activePanel.scrollHeight;
      activePanel.style.position = '';
      l2wrap.style.height = h + 'px';
    } else {
      l2wrap.style.height = '0';
    }
  };

  const closeAll = () => {
    triggers.forEach((trigger) => {
      const panel = trigger.querySelector('.mega-menu');
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.querySelectorAll('.mega-menu__l1-item').forEach((t) => t.classList.remove('is-active'));
      panel.querySelectorAll('.mega-menu__l2').forEach((p) => p.classList.remove('is-active'));
      const l2wrap = panel.querySelector('.mega-menu__l2-panels');
      if (l2wrap) l2wrap.style.height = '0';
    });
  };

  const activateL2 = (megaMenu, index) => {
    const l2wrap = megaMenu.querySelector('.mega-menu__l2-panels');
    megaMenu.querySelectorAll('.mega-menu__l1-item').forEach((tile) => {
      tile.classList.toggle('is-active', tile.dataset.megaIndex == index);
    });
    let activePanel = null;
    megaMenu.querySelectorAll('.mega-menu__l2').forEach((panel) => {
      const active = panel.dataset.megaPanel == index;
      panel.classList.toggle('is-active', active);
      if (active) activePanel = panel;
    });
    setL2Height(l2wrap, activePanel);
  };

  triggers.forEach((trigger) => {
    const megaMenu = trigger.querySelector('.mega-menu');
    if (!megaMenu) return;

    let closeTimer = null;

    const scheduleClose = () => {
      closeTimer = setTimeout(() => {
        megaMenu.classList.remove('is-open');
        megaMenu.setAttribute('aria-hidden', 'true');
        megaMenu.querySelectorAll('.mega-menu__l1-item').forEach((t) => t.classList.remove('is-active'));
        megaMenu.querySelectorAll('.mega-menu__l2').forEach((p) => p.classList.remove('is-active'));
        const l2wrap = megaMenu.querySelector('.mega-menu__l2-panels');
        if (l2wrap) l2wrap.style.height = '0';
      }, 120);
    };

    const cancelClose = () => {
      clearTimeout(closeTimer);
      closeTimer = null;
    };

    trigger.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      cancelClose();
      closeAll();
      setMegaTop(megaMenu);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
    });

    trigger.addEventListener('mouseleave', () => { if (isDesktop()) scheduleClose(); });
    megaMenu.addEventListener('mouseenter', () => { if (isDesktop()) cancelClose(); });
    megaMenu.addEventListener('mouseleave', () => { if (isDesktop()) scheduleClose(); });

    megaMenu.querySelectorAll('.mega-menu__l1-item[data-mega-index]').forEach((tile) => {
      tile.addEventListener('mouseenter', () => {
        if (isDesktop()) activateL2(megaMenu, tile.dataset.megaIndex);
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (isDesktop() && !e.target.closest('.menu-item-has-children')) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
};

// ── Mobile: burger + accordion submenu ───────────────────────────────────────

export const menuToggle = () => {
  const toggleBtn = document.getElementById('toggleMenu');
  const mobileMenu = document.getElementById('mobileMenu');
  const header = document.getElementById('header');

  if (!toggleBtn || !mobileMenu) return;

  // ---- sub-menu helpers ----

  const openSub = (li) => {
    const sub = li.querySelector(':scope > .sub-menu');
    if (!sub) return;
    li.classList.add('is-open');
    // Mierzymy naturalną wysokość: tymczasowo bez overflow i height
    sub.style.height = 'auto';
    const h = sub.scrollHeight;
    sub.style.height = '0';
    // Wymuszamy reflow (działa na Safari)
    sub.offsetHeight; // eslint-disable-line no-unused-expressions
    sub.style.height = h + 'px';
    sub.addEventListener('transitionend', () => {
      // Tylko jeśli nadal otwarte — ustaw auto żeby zawartość mogła rosnąć
      if (li.classList.contains('is-open')) sub.style.height = 'auto';
    }, { once: true });
  };

  const closeSub = (li) => {
    const sub = li.querySelector(':scope > .sub-menu');
    if (!sub) return;
    // Jeśli height jest 'auto' — najpierw ustaw konkretną wartość
    sub.style.height = sub.scrollHeight + 'px';
    // Wymuszamy reflow (działa na Safari)
    sub.offsetHeight; // eslint-disable-line no-unused-expressions
    sub.style.height = '0';
    li.classList.remove('is-open');
    sub.addEventListener('transitionend', () => {
      if (!li.classList.contains('is-open')) sub.style.height = '';
    }, { once: true });
  };

  const resetAll = () => {
    mobileMenu.querySelectorAll('.menu-item-has-children.is-open').forEach((li) => {
      li.classList.remove('is-open');
      const sub = li.querySelector(':scope > .sub-menu');
      if (sub) sub.style.height = '';
    });
  };

  // ---- burger toggle ----

  const openMenu = () => {
    toggleBtn.classList.add('active');
    mobileMenu.classList.add('isOpen');
    if (header) header.classList.add('menuIsOpen');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
  };

  const closeMenu = () => {
    toggleBtn.classList.remove('active');
    mobileMenu.classList.remove('isOpen');
    if (header) header.classList.remove('menuIsOpen');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    resetAll();
  };

  toggleBtn.addEventListener('click', () => {
    mobileMenu.classList.contains('isOpen') ? closeMenu() : openMenu();
  });

  // ---- accordion ----

  mobileMenu.querySelectorAll('.menu-item-has-children > a').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      // Nie używamy stopPropagation — może blokować inne listenery na Safari
      const li = link.closest('.menu-item-has-children');

      // Zamknij rodzeństwo na tym samym poziomie
      li.parentElement.querySelectorAll(':scope > .menu-item-has-children.is-open').forEach((sib) => {
        if (sib !== li) closeSub(sib);
      });

      li.classList.contains('is-open') ? closeSub(li) : openSub(li);
    });
  });

  // ---- linki-liście zamykają menu ----
  mobileMenu.querySelectorAll('.menu-item:not(.menu-item-has-children) > a').forEach((link) => {
    link.addEventListener('click', () => closeMenu());
  });
};
